import { autoCapitalize } from '@/utils/autoCapitalize'
import { ParticipantsResponse } from './Participants.types'

class ParticipantsMapper {
  toDomain(persistenceData: ParticipantsResponse) {
    return {
      userId: persistenceData?.idUsuario,
      name: autoCapitalize(persistenceData?.nome),
      descriptionProfile: autoCapitalize(persistenceData?.perfilDescricao),
    }
  }
}

export default new ParticipantsMapper()
